import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnvService } from 'src/app/service/env.service';
declare var $: any;


@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss']
})
export class OffersComponent implements OnInit ,OnDestroy {

  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  language: any;
  offers:any[]=[];
  currentIndex: number[] = [];
  @HostBinding('attr.dir') direction: string = document.dir || 'ltr'; // Get the direction from the document
  AppId;
  @HostListener('window:beforeunload', ['$event'])
  clearLocalStorage(event: Event) {
    localStorage.removeItem('Reloaded')
  }
  constructor(public EnvService : EnvService,private cdr: ChangeDetectorRef,private fb: FormBuilder,private HospitalService: HospitalService,private route: ActivatedRoute, private router: Router,
    private translationService: TranslationService, private auth: AuthService, private toast: HotToastService) {
  }
  ngOnInit(): void {
    this.LoadAllOffers();
    this.AppId = this.route.snapshot.params['AppId'];
    if(!this.AppId || this.AppId == null)
    {
      this.AppId = 0;
    }
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
    this.currentIndex.push(0);
    if (!localStorage.getItem('Reloaded'))
    {
      this.LogOffer();
      localStorage.setItem('Reloaded','true')
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
    localStorage.removeItem('Reloaded')
  }
  nextSlide(sectionIndex: number,sectionId) {
    const totalSlides = this.offers[sectionIndex].apiOfferImages.length;
    if (this.currentIndex[sectionIndex] < totalSlides - 1) {
      this.currentIndex[sectionIndex]++;
    } else {
      this.currentIndex[sectionIndex] = 0; // Loop back to the first slide
    }
    this.updateActiveSlide(sectionIndex);
    this.cdr.detectChanges(); // Explicitly trigger change detection
    this.TrackOffer('Next Action',null,sectionId);

  }
  // Helper method to calculate the correct transform based on the direction (RTL or LTR)
  getTransform(sectionIndex: number): string {
    const slideIndex = this.currentIndex[sectionIndex];
    // If it's RTL, we reverse the direction of the transform
    return this.direction === 'rtl'
      ? `translateX(${slideIndex * 100}%)`
      : `translateX(${-slideIndex * 100}%)`;
  }
  prevSlide(sectionIndex: number,sectionId) {
  
    if (this.currentIndex[sectionIndex] > 0) {
      this.currentIndex[sectionIndex]--;
    } else {
      this.currentIndex[sectionIndex] = this.offers[sectionIndex].apiOfferImages.length - 1; // Loop to the last slide
    }
    this.updateActiveSlide(sectionIndex);
    this.cdr.detectChanges(); // Explicitly trigger change detection
    this.TrackOffer('Previous Action',null,sectionId);
  }
  
  updateActiveSlide(sectionIndex: number) {
    const slides = document.querySelectorAll(`.slider-container:nth-child(${sectionIndex + 1}) .slide`);
    slides.forEach((slide, idx) => {
      if (idx === this.currentIndex[sectionIndex]) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  }
  
  LoadAllOffers()
  {
    const sb = this.HospitalService.GetAllOffers().subscribe(res => {
      if (res.data != null && res.isSuccess) {
        this.offers = res.data;
        setTimeout(() => {
          let items = document.querySelectorAll('.HospitalNewscarousel .HospitalNewscarousel-item');
          items.forEach((el) => {
            const minPerSlide = 3;
            let next = el.nextElementSibling;
            for (var i = 1; i < minPerSlide; i++) {
              if (!next) {
                // wrap carousel by using first child
                next = items[0];
              }
              let cloneChild = next.cloneNode(true) as any;
              el.appendChild(cloneChild.children[0]);
              next = next.nextElementSibling;
            }
          });
        }, 0);
      }
    });
  
    this.subscriptions.push(sb);
    
  }

  LogOffer() {
   let offerLog = {
    Id : 0,
    ApplicationId : this.AppId
   }
   this.HospitalService.AddOfferLog(offerLog).subscribe(res => console.log(res));
  }
  TrackOffer(ActionName,OfferId,OfferSectionId) {
    let offerLog = {
     Id : 0,
     ApplicationId : this.AppId,
     Action : ActionName,
     InsertionDate:new Date(),
     OfferId:OfferId,
     OfferSectionId : OfferSectionId,
    }
    this.HospitalService.AddOfferTrack(offerLog).subscribe(res => console.log(res));
   }
}
